import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to determine if a language code represents a Right-to-Left (RTL) language.
 * Returns 'rtl' or 'ltr' for use with the HTML dir attribute.
 *
 * Usage: [dir]="languageCode | isRtl"
 */
@Pipe({
  name: 'isRtl'
})
export class IsRtlPipe implements PipeTransform {

  private static readonly RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur', 'yi', 'ps', 'sd', 'ku'];

  public transform(languageCode: string | undefined | null): 'rtl' | 'ltr' | 'auto' {
    if (!languageCode) {
      return 'auto'; //'ltr';
    }
    const lang = languageCode.split('-')[0].toLowerCase();
    return 'auto'; // IsRtlPipe.RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr';
  }
}
